import { useEffect, useState } from "react";
import { ModelRenderer } from "../ModelRenderer";
import { URDFRobot } from "urdf-loader";
import { ArmMotionMapper, Model, MotionMapperType } from "../../models/Model";
import { MREvents } from "../MREvents";
import { Box, Button } from "@mui/material";
import { PropValueLine } from "../common/PropValueLine";
import { ArmAnimator } from "../../visuals/ArmAnimator";
import { Vec3 } from "../../models/SyntheticMap";
import { Vec3Editor } from "../common/Vec3Editor";
import * as THREE from "three";
import { copyVec3 } from "../../visuals/visual-utils";
import { set } from "ace-builds-internal/config";

const defaultMapper: ArmMotionMapper = {
  type: MotionMapperType.RobotArm,
  joints: {} as any,
};

export function ArmAnimationPropsPanel({
  mr,
  robot,
}: {
  mr: ModelRenderer;
  robot: URDFRobot;
}) {
  // const [mapper, setMapper] = useState<QRMotionMapper>();
  const [cfg, setCfg] = useState<ArmMotionMapper>(defaultMapper);
  const [targetPosition, setTargetPosition] = useState<Vec3>({
    x: 0,
    y: 0,
    z: 1.0,
  });
  useEffect(() => {
    if (!robot) {
      return;
    }
    const modelUpdatesListener = (model: Model) => {
      if (model.motionMapper.type === MotionMapperType.RobotArm) {
        setCfg(model.motionMapper as ArmMotionMapper);
        mr.animator = new ArmAnimator(mr.loader);
      } else {
        setCfg(defaultMapper);
      }
    };
    mr.onEvent(MREvents.ModelUpdated, modelUpdatesListener);
    modelUpdatesListener(mr.loader.model);
    const a = mr.animator as ArmAnimator;
    setTargetPosition(a.getPosition());
    return () => {
      mr.removeListener(MREvents.ModelUpdated, modelUpdatesListener);
    };
  }, [robot]);

  const mergeMapper = (mapper: Partial<ArmMotionMapper>) => {
    const updatedMapper = { ...cfg, ...mapper };
    setCfg(updatedMapper);
    const model = mr.loader.model;
    model.motionMapper = updatedMapper as ArmMotionMapper;
    mr.animator = new ArmAnimator(mr.loader);
  };

  return (
    <>
      <PropValueLine
        label="Position"
        value={
          <Vec3Editor
            value={targetPosition}
            onChange={(v) => setTargetPosition(v)}
          />
        }
      />
      <Box>
        <Button
          size="small"
          variant="outlined"
          color="error"
          onClick={() => {
            const a = mr.animator as ArmAnimator;
            const v = {
              x: targetPosition.x,
              y: targetPosition.y,
              z: targetPosition.z,
            };
            // const movePos = new THREE.Vector3(0.5, 0.5, 0.65);
            // copyVec3(movePos, v);
            // setTargetPosition(v);
            a.moveArm(v);
          }}
        >
          Move
        </Button>
        <Button
          size="small"
          variant="outlined"
          color="error"
          onClick={() => {
            const a = mr.animator as ArmAnimator;
            const vStow = { x: 0.1, y: 0, z: 0.5 }; // gen 3
            // const vStow = { x: 0.32, y: 0, z: 1.14 }; // kuka
            // const vStow = { x: 3.84, y: 0, z: 4.09 }; // abb
            setTargetPosition(vStow);
            a.moveArm(vStow);
          }}
        >
          STOW
        </Button>

        <Button
          size="small"
          variant="outlined"
          color="error"
          onClick={() => {
            const a = mr.animator as ArmAnimator;
            a.neutralize();
          }}
        >
          DEFAULTS
        </Button>
      </Box>
    </>
  );
}
